import React, {useEffect, useState} from 'react';
import CardItem, {url} from "../MenuCard/CardItem";
import ItemCard from "../MenuCard/ItemCard";
import {menus} from "../../content/food";

const Menus = ({onglet}) => {

    // const [isLoading, setIsLoading] = useState(true);
    // const [food, setMenus] = useState();
    //
    // useEffect(() => {
    //     fetch(`${url}/food`,
    //         {
    //             headers: {
    //                 'Accept': 'application/json'
    //             },
    //         }).then(res => res.json())
    //         .then(res => {
    //             setMenus(res);
    //            // setIsLoading(false);
    //         })
    // }, []);



    return (
        <div className={onglet === 1 ? "visible " : "hidden "}>
            <section className="mx-auto">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:mx-20 xl:mx-56">
                    {menus?.map(menu => <ItemCard key={menu.id} item={menu}/>)}
                </div>
            </section>
        </div>
    );
};

export default Menus;